<template>
  <div style="display:inline-block" @click="gotoChuZhi(menu.path)">

    <el-menu-item :index="menu.path || uniqueId">
      <i v-if="menu.icon" :class="`fa fa-${menu.icon}`"></i>
      <d2-icon-svg v-else-if="menu.iconSvg" :name="menu.iconSvg" />
      <i v-else class="fa fa-file-o"></i>
      <span slot="title">{{ menu.title || '未命名菜单' }}</span>

    </el-menu-item>
  </div>
</template>

<script>
import { uniqueId } from 'lodash'
export default {
  name: 'd2-layout-header-aside-menu-item',
  props: {
    menu: {
      type: Object,
      required: false,
      default: () => { }
    }
  },
  data() {
    return {
      uniqueId: uniqueId('d2-menu-empty-')
    }
  },
  methods: {
    gotoChuZhi(path) {
      if (path == '/caseMediate' ){
        let menuArr = this.$store.state.d2admin.menu.aside[0].children
        for(let i = 0 ; i < menuArr.length; i++){
            if(menuArr[i].path == '/caseMediate/czCaseInfo'){
                this.$router.push({ path: '/caseMediate/czCaseInfo' })

            }
        }
        
      }
 
      }
  }
}
</script>
